<template>
  <div class="container-mapas">
    <div class="left-box">
      <div class="title-section">
        <h2>Nordeste Meridional</h2>
      </div>
      <div>
          <!-- <p class="texto-apoio">Alagoas, Sergipe e Bahia compõem a região denominada de Nordeste Meridional.</p>
          <p>Faça download das Fichas-resumo das intervenções de cada Estado:</p> -->
          <div class="downloand">
              <ul>
								  <li>
                      <p>Fichas da Região</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Nordeste Meridional.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Alagoas - AL</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Alagoas.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Bahia - BA</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Bahia.zip" target="_blank">Download</a>
                  </li>
                  <li>
                      <p>Sergipe - SE</p>
                      <a href="http://arquivos.ana.gov.br/pnsh/Sergipe.zip" target="_blank">Download</a>
                  </li>
              </ul>
          </div>
          <div class="interacao-intervencao">
			<svg xmlns="http://www.w3.org/2000/svg" width="15" height="22" viewBox="0 0 15 22">
    			<path fill="#7E7E7E" fill-rule="evenodd" d="M13.278 12.965l-5.436-.492-.008-6.237C7.834 5.8 7.464 5 6.57 5c-.695 0-1.264.554-1.264 1.236V16.74l-1.049-1.473a1.255 1.255 0 0 0-1.894-.162 1.206 1.206 0 0 0-.141 1.559L4.94 21.62c.235.335.623.38 1.037.38h6.086c1.201 0 2.234-.678 2.47-1.832l.418-4.45c.249-1.223-.469-2.359-1.673-2.753M1.3 9C.582 9 0 8.464 0 7.8V6.3c0-8.4 13-8.4 13 0v1.5c0 .664-.582 1.2-1.3 1.2-.718 0-1.3-.536-1.3-1.2V6.3c0-4.8-7.8-4.8-7.8 0v1.5c0 .664-.582 1.2-1.3 1.2"/>
			</svg>
			<p>Explore o mapa e tenha acesso aos detalhes e à ficha-modelo de cada intervenção.</p>
		  </div>
      </div>
    </div>
    <div class="right-box">
      <div class="mapa">
				 <Modal />
         <SvgPanZoom :dblClickZoomEnabled="false" :zoomEnabled="true" :controlIconsEnabled="true" :fit="false"  :center="true" :contain="true">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 1076 1068" style="enable-background:new 0 0 1076 1068;" xml:space="preserve">

<path class="st0" d="M869.8,265.5l-0.3,9.4l-10.6-0.3c2.2-3.1,4.5-6.2,6.6-9.2L869.8,265.5z"/>
<path class="st0" d="M869.6,274.9l0.5,0.3c-10.4,14.4-22,30.6-33.8,46.8c-13.4,18.4-24.4,33.4-33.6,45.7l-0.9-0.6l4-8.5l-6-2.8
	c18-24.3,39-53.1,59.1-81.1L869.6,274.9z"/>
<path class="st0" d="M647.3,259.3l218.3,6.1c-2.2,3.1-4.4,6.1-6.6,9.2L654.7,269L647.3,259.3z"/>
<path class="st1" d="M654.7,269l204.3,5.6c-20.1,27.9-41.1,56.8-59.1,81.1l-116.5-55.2l-1.6,3.5L654.7,269z"/>
<path class="st0" d="M805.8,358.5l-4,8.5l-7.7-3.6c1.9-2.5,3.8-5.1,5.7-7.7L805.8,358.5z"/>
<path class="st0" d="M801.8,367.1l0.9,0.6c-39.8,53.5-43.7,55.3-45.9,56c-6.5,3-46.8,46.1-81.9,85.5l-48.3,310.9l-0.9-0.1l-7.9-4.4
	L666,505.1l0.9-1c0.2-0.2,19.1-21.5,38.9-42.8c7-7.5,12.9-13.8,17.9-19v1l9.4-0.6l-0.6-9.5c15.2-15.4,18.9-17.4,20.6-18.1
	c4-3,19.9-23.5,40.9-51.6L801.8,367.1z"/>
<path class="st0" d="M683.4,300.5l116.4,55.2c-1.9,2.6-3.9,5.2-5.7,7.7l-104.8-49.7l-7.5-9.8L683.4,300.5z"/>
<path class="st1" d="M689.3,313.7l104.8,49.7c-20.9,28.1-36.9,48.6-40.9,51.6c-1.8,0.7-5.4,2.7-20.6,18.1l-4.2-68.8L689.3,313.7z"/>
<path class="st0" d="M732.6,433l0.6,9.5l-9.4,0.6v-1C727.1,438.7,730,435.7,732.6,433z"/>
<path class="st0" d="M728.4,364.2l4.2,68.8c-2.6,2.6-5.5,5.6-8.9,9.1l-4.6-74.5L643,269.1l0.7-0.5l11.1,0.3l27.1,35l-2.4,5l9.9,4.7
	L728.4,364.2z"/>
<path class="st1" d="M719.2,367.7l4.6,74.5c-5,5.2-11,11.5-17.9,19c-19.8,21.4-38.7,42.7-38.9,42.8l-0.9,1l-48.2,310.6L575.5,792
	l25.2-99.2L355,582l-116.2,52.7L215.4,603L229,353l70.6,36l79.6-90.7l90.1-4.7l61.7-35.2l14.2,48.8l86.4-52.8l11.4,14.7L719.2,367.7
	z"/>
<polygon class="st0" points="689.3,313.7 679.4,309 681.8,303.9 "/>
<polygon class="st0" points="654.7,269 643.6,268.6 643.9,259.2 647.3,259.3 "/>
<polygon class="st0" points="647.3,259.3 643.9,259.2 643.6,268.6 643,269.1 631.6,254.5 545.2,307.3 531,258.4 469.4,293.7
	379.2,298.4 299.6,389.1 229.1,353 227.9,352.8 230.2,343 297.4,377.3 374.8,289.2 466.6,284.4 505.4,262.2 509.8,264.6
	513.5,257.6 536.8,244.3 550.8,292.8 633.9,242 "/>
<polygon class="st0" points="625.7,820 621,828.3 616.2,825.6 617.8,815.6 "/>
<polygon class="st0" points="617.8,815.6 616.2,825.6 570,799.7 574.1,797.5 575.5,792 "/>
<polygon class="st0" points="572.3,790.2 575.5,792 574.1,797.5 570,799.7 567.7,798.5 "/>
<polygon class="st0" points="513.5,257.6 509.8,264.6 505.4,262.2 "/>
<path class="st0" d="M230.2,343l-2.2,9.8l-0.4,1.6l-5.9-5.3c0,0-0.6-0.6-1.7-1.5l0.5-9.5l0.6,0.3L230.2,343z"/>
<path class="st0" d="M227.6,354.3l0.4-1.6l1.1,0.3l-13.6,250l-5.3-7.1l-4.1,7.2l5.1-92.8h1.1l0.2-9.4h-0.7l8.4-153.3
	c1.1,1,1.7,1.5,1.7,1.5L227.6,354.3z"/>
<polygon class="st0" points="215.4,603 215.3,604.7 205.9,604.2 206,603.1 210.2,595.9 "/>
<polygon class="st0" points="212.3,500.9 212.1,510.3 211.1,510.3 211.6,500.9 "/>
<polygon class="st0" points="570,799.7 568.6,796.8 567.7,798.5 "/>
<polyline class="st0" points="211.1,613 235.8,646.4 355,592.4 589.6,698.2 565.9,791.2 568.6,796.8 572.3,790.2 575.5,792
	600.6,692.8 355,582 238.8,634.7 215.4,603 215.3,604.7 205.9,604.2 206,603.1 "/>
<g @click="mostarIntervencao(1)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(1)">
	<circle class="st2" cx="529" cy="547.2" r="14.5"/>
	<circle class="st3" cx="529" cy="547.2" r="13"/>
	<circle class="st4" cx="529" cy="547.2" r="11.7"/>
	<path class="st5" d="M529.1,559.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C541.5,554.1,535.9,559.7,529.1,559.7z M529.1,536.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C540.1,541.1,535.2,536.2,529.1,536.2L529.1,536.2z"/>
	<g>
		<path class="st6" d="M528.4,543.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C528.6,543.2,528.5,543.2,528.4,543.1z"/>
		<path class="st6" d="M528.4,542.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C528.6,542.2,528.5,542.2,528.4,542.1z"/>
		<path class="st6" d="M521.4,553.2c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C521.5,553.2,521.5,553.2,521.4,553.2z"/>
		<path class="st6" d="M521.3,544.1c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5s-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0h-0.2l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2
			c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2C521.1,543.9,521.2,544,521.3,544.1z"/>
		<path class="st6" d="M521.4,544.1C521.3,544.1,521.3,544.1,521.4,544.1C521.3,544.1,521.3,544.1,521.4,544.1L521.4,544.1z"/>
		<path class="st6" d="M521.4,546.2C521.4,546.2,521.4,546.1,521.4,546.2C521.3,546.2,521.3,546.2,521.4,546.2L521.4,546.2z"/>
		<path class="st6" d="M526.2,544.9c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C526.3,545.2,526.3,545,526.2,544.9L526.2,544.9z"/>
		<path class="st6" d="M526.2,546.9c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1h-0.3H524v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C526.4,547.3,526.4,547.1,526.2,546.9L526.2,546.9z"
			/>
		<path class="st6" d="M526.2,548.9c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C526.3,549,526.2,548.9,526.2,548.9z"/>
		<path class="st6" d="M525.7,551L525.7,551c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C526,550.8,525.8,550.8,525.7,551z"/>
		<path class="st6" d="M533.2,551.7c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0H535h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0V553h-4.3c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C532.8,552.1,533,552,533.2,551.7z
			 M528,553.2h-0.7v-1h0.7V553.2z M528.7,553.2v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4
			s-0.4,0.1-0.4,0.3v0.1v7h-0.7v-10.4h2.4l2.2,12L528.7,553.2L528.7,553.2z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(22)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(22)">
	<circle class="st2" cx="740.9" cy="411.4" r="14.5"/>
	<circle class="st3" cx="740.9" cy="411.4" r="13"/>
	<circle class="st4" cx="740.9" cy="411.4" r="11.7"/>
	<path class="st5" d="M740.9,423.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C753.3,418.3,747.7,423.8,740.9,423.8z M740.9,400.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C751.9,405.3,747,400.3,740.9,400.3L740.9,400.3z"/>
	<g>
		<path class="st6" d="M740.2,407.3c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2s0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C740.4,407.4,740.3,407.3,740.2,407.3z"/>
		<path class="st6" d="M740.2,406.3c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C740.4,406.4,740.3,406.3,740.2,406.3z"/>
		<path class="st6" d="M733.2,417.3c-0.2,0-0.3,0.2-0.3,0.3c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C733.4,417.4,733.3,417.3,733.2,417.3z"/>
		<path class="st6" d="M733.1,408.3c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5V407l0,0l0,0l0,0H736l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C732.9,408.1,733,408.2,733.1,408.3z"/>
		<path class="st6" d="M733.2,408.3C733.2,408.3,733.1,408.3,733.2,408.3C733.1,408.3,733.1,408.3,733.2,408.3L733.2,408.3z"/>
		<path class="st6" d="M733.2,410.3L733.2,410.3C733.1,410.3,733.1,410.3,733.2,410.3L733.2,410.3z"/>
		<path class="st6" d="M738,409.1c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0H736h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C738.2,409.4,738.1,409.2,738,409.1L738,409.1z"/>
		<path class="st6" d="M738,411.1c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.1H736h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2s0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C738.3,411.4,738.2,411.2,738,411.1L738,411.1z"/>
		<path class="st6" d="M738,413.1c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C738.1,413.1,738,413.1,738,413.1z"/>
		<path class="st6" d="M737.5,415.2L737.5,415.2c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1H736l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C737.8,415,737.6,415,737.5,415.2z"/>
		<path class="st6" d="M745,415.9c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5V415
			l0,0h-0.3h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C744.6,416.3,744.9,416.1,745,415.9z
			 M739.9,417.3h-0.7v-1h0.7V417.3z M740.5,417.3v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7
			c0-0.2-0.1-0.4-0.3-0.4s-0.4,0.1-0.4,0.3v0.1v7h-0.7v-10.4h2.4l2.2,12L740.5,417.3L740.5,417.3z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(10)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(10)">
	<circle class="st2" cx="567.7" cy="621.1" r="14.5"/>
	<circle class="st3" cx="567.7" cy="621.1" r="13"/>
	<circle class="st4" cx="567.7" cy="621.1" r="11.7"/>
	<path class="st5" d="M567.7,633.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C580.1,627.9,574.5,633.5,567.7,633.5z M567.7,610c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C578.7,614.9,573.8,610,567.7,610L567.7,610z"/>
	<g>
		<path class="st6" d="M567,617c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.1,0-0.2-0.1-0.2C567.2,617,567.1,617,567,617z"/>
		<path class="st6" d="M567,616c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.1,0.3,0,0.5c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1
			c0.1-0.1,0.1-0.3,0-0.5C567.2,616,567.1,616,567,616z"/>
		<path class="st6" d="M560,627c-0.2,0-0.3,0.2-0.3,0.3s0,0.2,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0,0.3-0.1,0.3-0.3l0,0
			c0-0.1,0-0.2-0.1-0.2C560.2,627,560.1,627,560,627z"/>
		<path class="st6" d="M559.9,617.9c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0.1-0.4-0.1-0.5c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0l0,0l0,0h-0.2l0,0c0,0,0,0-0.1,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5
			s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2
			C559.7,617.7,559.8,617.8,559.9,617.9z"/>
		<path class="st6" d="M560,618C560,618,559.9,617.9,560,618C559.9,617.9,559.9,617.9,560,618L560,618z"/>
		<path class="st6" d="M560.1,620C560,620,560,620,560.1,620C560,620,560,620,560.1,620L560.1,620z"/>
		<path class="st6" d="M564.8,618.7c-0.1-0.1-0.3-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1l0,0h-0.3h-0.1
			c0,0,0,0,0,0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.3c0,0.1,0,0.3,0.2,0.3c0.1,0,0.1,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8
			C565,619,564.9,618.8,564.8,618.7L564.8,618.7z"/>
		<path class="st6" d="M564.8,620.7c-0.1-0.1-0.4-0.1-0.5,0.1c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1H563h-0.3h-0.1v0.1
			c-0.3,0.3-0.5,0.6-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.2c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8C565.1,621.1,565,620.9,564.8,620.7L564.8,620.7z"/>
		<path class="st6" d="M564.8,622.8c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.2l0,0
			c0,0,0,0-0.1,0l0,0c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.1-0.4-0.1-0.5,0.1
			c-0.2,0.2-0.5,0.6-0.7,0.5c-0.2,0-0.4,0.1-0.4,0.2l0,0c0,0.2,0.1,0.4,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4
			c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.2,0-0.4-0.1-0.5
			C564.9,622.8,564.8,622.8,564.8,622.8z"/>
		<path class="st6" d="M564.3,624.8L564.3,624.8c-0.3,0.4-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1h-0.3l0,0h-0.1v0.1
			c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1c-0.2,0.2-0.5,0.6-0.7,0.5
			c-0.2,0-0.4,0.1-0.4,0.3s0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.2,0c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c0,0-0.1,0-0.1-0.1
			C564.6,624.6,564.4,624.7,564.3,624.8z"/>
		<path class="st6" d="M571.8,625.6c0.2,0.2,0.5,0.4,0.8,0.4h0.1c0.3,0,0.7-0.2,0.9-0.4c0.2,0.2,0.5,0.4,0.8,0.4h0.1
			c0.5-0.1,0.9-0.3,1.2-0.8c0.1-0.1,0.1-0.4-0.1-0.5c-0.1-0.1-0.4-0.1-0.5,0.1l0,0c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.5v-0.1
			l0,0h-0.3h-0.1l0,0v0.1c-0.3,0.3-0.5,0.5-0.7,0.5s-0.4-0.3-0.5-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.4-0.1-0.5,0.1l0,0
			c-0.1,0.2-0.4,0.4-0.6,0.5l-2-10.7c0-0.2-0.2-0.3-0.3-0.3h-3c-0.2,0-0.3,0.1-0.3,0.3l0,0v12.3h-4.3c-0.2,0-0.3,0.2-0.3,0.3
			c0,0.2,0.1,0.3,0.3,0.3h14c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.2-0.3-0.3-0.3h-3.7l-0.2-1C571.4,625.9,571.7,625.8,571.8,625.6z
			 M566.7,627H566v-1h0.7V627z M567.3,627v-1h2c0.2,0,0.3-0.1,0.3-0.3l0,0c0-0.2-0.1-0.3-0.3-0.3h-2v-7c0-0.2-0.1-0.4-0.3-0.4
			s-0.4,0.1-0.4,0.3v0.1v7H566V615h2.4l2.2,12H567.3z"/>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(6)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(6)">
	<circle class="st2" cx="528" cy="595.9" r="14.5"/>
	<circle class="st3" cx="528" cy="595.9" r="13"/>
	<circle class="st4" cx="528" cy="595.9" r="11.7"/>
	<path class="st5" d="M528,608.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C540.4,602.8,534.9,608.3,528,608.3z M528,584.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C539.1,589.8,534.1,584.8,528,584.8L528,584.8z"/>
	<path class="st6" d="M535.5,595.5h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9c0.1-0.6-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3
		h-0.8v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-1l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9
		c-0.1,0.6,0.3,1.2,0.9,1.3c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2
		l0,0v0.3h-1.8v-0.8c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9
		c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2
		l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0v-5.4C535.8,595.6,535.7,595.5,535.5,595.5C535.6,595.5,535.6,595.5,535.5,595.5z M528.5,591.7
		h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1H531l-1.7-0.3h-0.9v-0.7H528.5z M522.1,600.9
		h-1.4V596h1.4V600.9z M527.4,590.8h0.6v0.3h-0.6V590.8z M527.4,591.6h0.6v0.6h-0.6V591.6z M527.4,592.7h0.6v1.7h-0.6V592.7z
		 M526,592.2L526,592.2l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6H526z
		 M526.3,594.9h2.8v1.1h-2.8V594.9z M522.6,597.1h1.8v2.8h-1.8V597.1z M530.4,600.4h-5.5v-3.9h5.5V600.4z M533.4,599.8h-2.5V597h2.5
		V599.8z M535.3,600.9h-1.4V596h1.4V600.9z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(9)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(9)">
	<circle class="st2" cx="611.7" cy="464.6" r="14.5"/>
	<circle class="st3" cx="611.7" cy="464.6" r="13"/>
	<circle class="st4" cx="611.7" cy="464.6" r="11.7"/>
	<path class="st5" d="M611.7,477c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C624.1,471.4,618.5,477,611.7,477z M611.7,453.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C622.7,458.5,617.8,453.5,611.7,453.5L611.7,453.5z"/>
	<path class="st6" d="M619.2,464.2h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5V465c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0H611c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7H610c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3V469h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0V469h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C619.5,464.3,619.3,464.2,619.2,464.2L619.2,464.2z M612.1,460.3h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L612.1,460.3z M605.7,469.6h-1.4v-4.9h1.4V469.6z M611,459.5h0.6v0.3H611
		V459.5z M611,460.3h0.6v0.6H611V460.3z M611,461.4h0.6v1.7H611V461.4z M609.7,460.9L609.7,460.9l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L609.7,460.9z M609.9,463.6h2.8v1.1h-2.8V463.6z
		 M606.2,465.7h1.8v2.8h-1.8V465.7z M614.1,469.1h-5.5v-3.9h5.5V469.1z M617.1,468.5h-2.5v-2.8h2.5V468.5z M619,469.6h-1.4v-4.9h1.4
		V469.6z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(25)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(25)">
	<circle class="st2" cx="638.5" cy="425.9" r="14.5"/>
	<circle class="st3" cx="638.5" cy="425.9" r="13"/>
	<circle class="st4" cx="638.5" cy="425.9" r="11.7"/>
	<path class="st5" d="M638.5,438.3c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C650.9,432.8,645.4,438.3,638.5,438.3z M638.5,414.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C649.6,419.8,644.6,414.9,638.5,414.9L638.5,414.9z"/>
	<path class="st6" d="M646,425.5h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0H640v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0H639v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3H639v-0.6
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C646.3,425.6,646.2,425.5,646,425.5L646,425.5z M638.9,421.7h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3H639L638.9,421.7L638.9,421.7z M632.6,431h-1.4v-5h1.4V431z M637.9,420.9h0.6v0.3
		h-0.6V420.9z M637.9,421.7h0.6v0.6h-0.6V421.7z M637.9,422.8h0.6v1.7h-0.6V422.8z M636.5,422.3L636.5,422.3l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L636.5,422.3z M636.8,424.9h2.8v1.1h-2.8V424.9z
		 M633.1,427.1h1.8v2.8h-1.8V427.1z M640.9,430.4h-5.5v-3.9h5.5V430.4z M643.9,429.9h-2.5v-2.8h2.5V429.9z M645.8,431h-1.4v-5h1.4
		V431z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(8)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(8)">
	<circle class="st2" cx="682.3" cy="412.1" r="14.5"/>
	<circle class="st3" cx="682.3" cy="412.1" r="13"/>
	<circle class="st4" cx="682.3" cy="412.1" r="11.7"/>
	<path class="st5" d="M682.3,424.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C694.8,419,689.2,424.5,682.3,424.5z M682.3,401c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C693.4,406,688.5,401,682.3,401L682.3,401z"/>
	<path class="st6" d="M689.9,411.7H688c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0H684v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0H683V409h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3H683v-0.6
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4H679c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3H677V412
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		V412C690.1,411.8,690,411.7,689.9,411.7L689.9,411.7z M682.8,407.9h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L682.8,407.9L682.8,407.9z M676.4,417.1H675v-4.9h1.4V417.1z M681.7,407h0.6
		v0.3h-0.6V407z M681.7,407.8h0.6v0.6h-0.6V407.8z M681.7,408.9h0.6v1.7h-0.6V408.9z M680.4,408.4L680.4,408.4l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L680.4,408.4z M680.6,411.1h2.8v1.1h-2.8V411.1z
		 M676.9,413.3h1.8v2.8h-1.8V413.3z M684.8,416.6h-5.5v-3.9h5.5V416.6z M687.8,416h-2.5v-2.8h2.5V416z M689.7,417.1h-1.4v-4.9h1.4
		V417.1z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(5)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(5)">
	<circle class="st2" cx="580.7" cy="373.4" r="14.5"/>
	<circle class="st3" cx="580.7" cy="373.4" r="13"/>
	<circle class="st4" cx="580.7" cy="373.4" r="11.7"/>
	<path class="st5" d="M580.7,385.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C593.1,380.3,587.6,385.8,580.7,385.8z M580.7,362.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C591.8,367.3,586.8,362.3,580.7,362.3L580.7,362.3z"/>
	<path class="st6" d="M588.2,373h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8V368
		c0-0.1-0.1-0.2-0.2-0.2l0,0H580c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7H579c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C588.5,373.1,588.4,373,588.2,373L588.2,373z M581.1,369.2h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L581.1,369.2L581.1,369.2z M574.8,378.4h-1.4v-4.9h1.4V378.4z M580.1,368.3
		h0.6v0.3h-0.6V368.3z M580.1,369.1h0.6v0.6h-0.6V369.1z M580.1,370.2h0.6v1.7h-0.6V370.2z M578.7,369.7L578.7,369.7L577,370h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L578.7,369.7z M579,372.4h2.8v1.1H579V372.4z
		 M575.3,374.6h1.8v2.8h-1.8V374.6z M583.1,377.9h-5.5V374h5.5V377.9z M586.1,377.3h-2.5v-2.8h2.5V377.3z M588,378.4h-1.4v-4.9h1.4
		V378.4z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(16)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(16)">
	<circle class="st2" cx="847.9" cy="272.2" r="14.5"/>
	<circle class="st3" cx="847.9" cy="272.2" r="13"/>
	<circle class="st4" cx="847.9" cy="272.2" r="11.7"/>
	<path class="st5" d="M847.9,284.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C860.3,279.1,854.7,284.7,847.9,284.7z M847.9,261.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C858.9,266.1,854,261.2,847.9,261.2L847.9,261.2z"/>
	<path class="st6" d="M855.4,271.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1V271
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0H847c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7H846c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C855.7,272,855.6,271.9,855.4,271.9L855.4,271.9z M848.3,268h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		s-0.2,0.7-0.5,0.8l0,0H851h-0.1l-1.7-0.3h-0.9V268z M842,277.3h-1.4v-4.9h1.4V277.3z M847.2,267.2h0.6v0.3h-0.6V267.2z M847.2,268
		h0.6v0.6h-0.6V268z M847.2,269.1h0.6v1.7h-0.6V269.1z M845.9,268.6L845.9,268.6l-1.7,0.3H844c-0.4,0-0.6-0.3-0.7-0.6
		c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L845.9,268.6z M846.2,271.3h2.8v1.1h-2.8V271.3z M842.5,273.4h1.8v2.8
		h-1.8V273.4z M850.3,276.7h-5.5v-3.9h5.5V276.7z M853.3,276.2h-2.5v-2.8h2.5V276.2z M855.2,277.3h-1.4v-4.9h1.4V277.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(21)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(21)">
	<circle class="st2" cx="743.4" cy="346.9" r="14.5"/>
	<circle class="st3" cx="743.4" cy="346.9" r="13"/>
	<circle class="st4" cx="743.4" cy="346.9" r="11.7"/>
	<path class="st5" d="M743.4,359.3c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C755.8,353.8,750.3,359.3,743.4,359.3z M743.4,335.8c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C754.5,340.8,749.5,335.9,743.4,335.8L743.4,335.8z"/>
	<path class="st6" d="M750.9,346.5H749c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0H745v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0H744v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3H744v-0.6
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3H738v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C751.2,346.6,751.1,346.5,750.9,346.5C751,346.5,751,346.5,750.9,346.5z M743.9,342.7h0.8c0,0,0,0,0.1,0l1.7-0.3
		c0.4-0.1,0.7,0.2,0.8,0.5c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3H744L743.9,342.7L743.9,342.7z M737.5,351.9h-1.4V347h1.4
		V351.9z M742.8,341.9h0.6v0.3h-0.6V341.9z M742.8,342.7h0.6v0.6h-0.6V342.7z M742.8,343.8h0.6v1.7h-0.6V343.8z M741.4,343.3
		L741.4,343.3l-1.7,0.3h-0.1c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L741.4,343.3z
		 M741.7,345.9h2.8v1.1h-2.8V345.9z M738,348.1h1.8v2.8H738V348.1z M745.8,351.4h-5.5v-3.9h5.5V351.4z M748.8,350.9h-2.5v-2.8h2.5
		V350.9z M750.7,351.9h-1.4V347h1.4V351.9z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(20)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(20)">
	<circle class="st2" cx="740" cy="376.6" r="14.5"/>
	<circle class="st3" cx="740" cy="376.6" r="13"/>
	<circle class="st4" cx="740" cy="376.6" r="11.7"/>
	<path class="st5" d="M740,389c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C752.5,383.4,746.9,389,740,389z M740,365.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C751.1,370.4,746.2,365.5,740,365.5L740,365.5z"/>
	<path class="st6" d="M747.6,376.2h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H743V377c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0H733c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3V381h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0V381h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C747.9,376.3,747.7,376.2,747.6,376.2L747.6,376.2z M740.5,372.3h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1h-0.1l-1.7-0.3h-0.9L740.5,372.3L740.5,372.3z M734.1,381.6h-1.4v-4.9h1.4V381.6z M739.4,371.5
		h0.6v0.3h-0.6V371.5z M739.4,372.3h0.6v0.6h-0.6V372.3z M739.4,373.4h0.6v1.7h-0.6V373.4z M738.1,372.9L738.1,372.9l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L738.1,372.9z M738.3,375.6h2.8v1.1h-2.8V375.6z
		 M734.6,377.7h1.8v2.8h-1.8V377.7z M742.5,381.1H737v-3.9h5.5V381.1z M745.5,380.5H743v-2.8h2.5V380.5z M747.4,381.6H746v-4.9h1.4
		V381.6z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(19)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(19)">
	<circle class="st2" cx="776" cy="367.1" r="14.5"/>
	<circle class="st3" cx="776" cy="367.1" r="13"/>
	<circle class="st4" cx="776" cy="367.1" r="11.7"/>
	<path class="st5" d="M776,379.5c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C788.4,373.9,782.9,379.5,776,379.5z M776,356c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C787.1,361,782.1,356,776,356L776,356z"/>
	<path class="st6" d="M783.6,366.7h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8H779v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0H769c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C783.8,366.8,783.7,366.7,783.6,366.7L783.6,366.7z M776.5,362.8h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1H779l-1.7-0.3h-0.9L776.5,362.8z M770.1,372.1h-1.4v-4.9h1.4V372.1z M775.4,362h0.6v0.3h-0.6V362
		z M775.4,362.8h0.6v0.6h-0.6V362.8z M775.4,363.9h0.6v1.7h-0.6V363.9z M774.1,363.4L774.1,363.4l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L774.1,363.4z M774.3,366.1h2.8v1.1h-2.8V366.1z
		 M770.6,368.2h1.8v2.8h-1.8V368.2z M778.5,371.6H773v-3.9h5.5V371.6z M781.4,371H779v-2.8h2.5L781.4,371L781.4,371z M783.4,372.1
		H782v-4.9h1.4V372.1z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(15)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(15)">
	<circle class="st2" cx="829" cy="303.6" r="14.5"/>
	<circle class="st3" cx="829" cy="303.6" r="13"/>
	<circle class="st4" cx="829" cy="303.6" r="11.7"/>
	<path class="st5" d="M829,316c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C841.4,310.4,835.9,316,829,316z M829,292.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C840.1,297.5,835.1,292.5,829,292.5L829,292.5z"/>
	<path class="st6" d="M836.5,303.2h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5V304c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-1l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7H827c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3V308h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0V308h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C836.8,303.3,836.7,303.2,836.5,303.2L836.5,303.2z M829.4,299.3h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1H832l-1.7-0.3h-0.9L829.4,299.3L829.4,299.3z M823.1,308.6h-1.4v-4.9h1.4V308.6z M828.4,298.5
		h0.6v0.3h-0.6V298.5z M828.4,299.3h0.6v0.6h-0.6V299.3z M828.4,300.4h0.6v1.7h-0.6V300.4z M827,299.9L827,299.9l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L827,299.9z M827.3,302.6h2.8v1.1h-2.8V302.6z
		 M823.6,304.7h1.8v2.8h-1.8V304.7z M831.4,308.1h-5.5v-3.9h5.5V308.1z M834.4,307.5h-2.5v-2.8h2.5V307.5z M836.3,308.6h-1.4v-4.9
		h1.4V308.6z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(4)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(4)">
	<circle class="st2" cx="643" cy="475.3" r="14.5"/>
	<circle class="st3" cx="643" cy="475.3" r="13"/>
	<circle class="st4" cx="643" cy="475.3" r="11.7"/>
	<path class="st5" d="M643,487.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C655.4,482.1,649.9,487.7,643,487.7z M643,464.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C654.1,469.2,649.1,464.2,643,464.2L643,464.2z"/>
	<path class="st6" d="M650.5,474.9h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5v-0.3c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1V474
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8V470
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-1l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3v-0.8h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0v-0.3h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C650.8,475,650.7,474.9,650.5,474.9L650.5,474.9z M643.4,471.1h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0h-0.1H646l-1.7-0.3h-0.9L643.4,471.1z M637.1,480.3h-1.4v-4.9h1.4V480.3z M642.4,470.2h0.6v0.3h-0.6
		V470.2z M642.4,471h0.6v0.6h-0.6V471z M642.4,472.1h0.6v1.7h-0.6V472.1z M641,471.6L641,471.6l-1.7,0.3h-0.1
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L641,471.6z M641.3,474.3h2.8v1.1h-2.8V474.3z
		 M637.6,476.4h1.8v2.8h-1.8V476.4z M645.4,479.8h-5.5v-3.9h5.5V479.8z M648.4,479.2h-2.5v-2.8h2.5V479.2z M650.3,480.3h-1.4v-4.9
		h1.4V480.3z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(3)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(3)">
	<circle class="st2" cx="674.8" cy="481.6" r="14.5"/>
	<circle class="st3" cx="674.8" cy="481.6" r="13"/>
	<circle class="st4" cx="674.8" cy="481.6" r="11.7"/>
	<path class="st5" d="M674.8,494c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C687.3,488.4,681.7,494,674.8,494z M674.8,470.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C685.9,475.5,680.9,470.5,674.8,470.5L674.8,470.5z"/>
	<path class="st6" d="M682.4,481.2h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.8h-2.5V482c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1v-1.4
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-0.8v-1.7h0.8l1.6,0.3c0.6,0.1,1.2-0.3,1.3-0.9s-0.3-1.2-0.9-1.3c-0.1,0-0.3,0-0.4,0l-1.6,0.3h-0.8
		v-0.6c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.1c-0.1,0-0.2,0.1-0.3,0.2l0,0v0.6h-0.8l-1.6-0.3c-0.6-0.1-1.2,0.3-1.3,0.9s0.3,1.2,0.9,1.3
		c0.1,0,0.3,0,0.4,0l1.6-0.3h0.9v1.7h-0.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.4h-1.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v0.3h-1.8v-0.8
		c0-0.1-0.1-0.2-0.2-0.2l0,0h-1.9c-0.1,0-0.2,0.1-0.2,0.2l0,0v5.4c0,0.1,0.1,0.2,0.2,0.3h1.9c0.1,0,0.2-0.1,0.2-0.3V486h1.8v0.3
		c0,0.1,0.1,0.2,0.2,0.2l0,0h6c0.1,0,0.2-0.1,0.2-0.2l0,0V486h2.5v0.8c0,0.1,0.1,0.2,0.2,0.2l0,0h1.9c0.1,0,0.2-0.1,0.2-0.2l0,0
		v-5.4C682.6,481.3,682.5,481.2,682.4,481.2L682.4,481.2z M675.3,477.3h0.8c0,0,0,0,0.1,0l1.7-0.3c0.4-0.1,0.7,0.2,0.8,0.5
		c0.1,0.4-0.2,0.7-0.5,0.8l0,0H678h-0.1l-1.7-0.3h-0.9V477.3z M668.9,486.6h-1.4v-4.9h1.4V486.6z M674.2,476.5h0.6v0.3h-0.6V476.5z
		 M674.2,477.3h0.6v0.6h-0.6V477.3z M674.2,478.4h0.6v1.7h-0.6V478.4z M672.9,477.9L672.9,477.9l-1.7,0.3H671
		c-0.4,0-0.6-0.3-0.7-0.6c0-0.3,0.2-0.6,0.5-0.6c0.1,0,0.2,0,0.3,0l1.7,0.3h0.9v0.6L672.9,477.9z M673.1,480.6h2.8v1.1h-2.8V480.6z
		 M669.4,482.7h1.8v2.8h-1.8V482.7z M677.3,486.1h-5.5v-3.9h5.5V486.1z M680.3,485.5h-2.5v-2.8h2.5V485.5z M682.2,486.6h-1.4v-4.9
		h1.4V486.6z"/>
	</v-touch>
</g>
<g @click="mostarIntervencao(2)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(2)">
		<ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 -231.4563 579.9557)" class="st2" cx="225.1" cy="426" rx="14.5" ry="14.5"/>
	<ellipse transform="matrix(0.1602 -0.9871 0.9871 0.1602 -231.4563 579.9557)" class="st3" cx="225.1" cy="426" rx="13" ry="13"/>
	<circle class="st4" cx="225.1" cy="426" r="11.7"/>
	<g>
		<path class="st5" d="M225.1,438.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C237.5,432.8,231.9,438.4,225.1,438.4z M225.1,414.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C236.2,419.8,231.2,414.9,225.1,414.9L225.1,414.9z"/>
		<g>
			<path class="st6" d="M228.7,424.3c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C229,424.7,228.9,424.4,228.7,424.3z"/>
			<path class="st6" d="M220.9,422.5c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1s0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C220.8,422,220.7,422.3,220.9,422.5L220.9,422.5z"/>
			<path class="st6" d="M232.2,420.8h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4H218c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C232.7,421,232.5,420.8,232.2,420.8z M231.9,430.4h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L231.9,430.4L231.9,430.4z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(31)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(31)">
	<circle class="st2" cx="559.8" cy="338" r="14.5"/>
	<circle class="st3" cx="559.8" cy="338" r="13"/>
	<circle class="st4" cx="559.8" cy="338" r="11.7"/>
	<g>
		<path class="st5" d="M559.8,350.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C572.2,344.9,566.7,350.5,559.8,350.5z M559.8,327c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C570.9,331.9,565.9,327,559.8,327L559.8,327z"/>
		<g>
			<path class="st6" d="M563.5,336.3c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C563.7,336.7,563.7,336.5,563.5,336.3z"/>
			<path class="st6" d="M555.6,334.6c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C555.5,334.1,555.5,334.4,555.6,334.6L555.6,334.6z"/>
			<path class="st6" d="M566.9,332.8H566c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C567.5,333.1,567.2,332.8,566.9,332.8z M566.7,342.4h-0.8l0,0h-10.8l0,0H553v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L566.7,342.4L566.7,342.4z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(12)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(12)">
	<circle class="st2" cx="687.3" cy="284.7" r="14.5"/>
	<circle class="st3" cx="687.3" cy="284.7" r="13"/>
	<circle class="st4" cx="687.3" cy="284.7" r="11.7"/>
	<g>
		<path class="st5" d="M687.3,297.1c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C699.7,291.5,694.1,297.1,687.3,297.1z M687.3,273.6c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C698.3,278.6,693.4,273.6,687.3,273.6L687.3,273.6z"/>
		<g>
			<path class="st6" d="M690.9,283c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C691.2,283.4,691.1,283.1,690.9,283z"/>
			<path class="st6" d="M683.1,281.2c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C683,280.7,682.9,281,683.1,281.2C683,281.2,683,281.2,683.1,281.2z"/>
			<path class="st6" d="M694.3,279.5h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5H684c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6V280C694.9,279.7,694.7,279.5,694.3,279.5z M694.1,289.1h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L694.1,289.1L694.1,289.1z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(13)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(13)">
	<circle class="st2" cx="718.7" cy="289.1" r="14.5"/>
	<circle class="st3" cx="718.7" cy="289.1" r="13"/>
	<circle class="st4" cx="718.7" cy="289.1" r="11.7"/>
	<g>
		<path class="st5" d="M718.7,301.5c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C731.1,295.9,725.5,301.5,718.7,301.5z M718.7,278c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C729.8,283,724.8,278,718.7,278L718.7,278z"/>
		<g>
			<path class="st6" d="M722.3,287.4c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C722.6,287.8,722.5,287.5,722.3,287.4z"/>
			<path class="st6" d="M714.5,285.6c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C714.4,285.2,714.3,285.4,714.5,285.6L714.5,285.6z"/>
			<path class="st6" d="M725.8,283.9h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C726.3,284.1,726.1,283.9,725.8,283.9z M725.5,293.5h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L725.5,293.5L725.5,293.5z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(14)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(14)">
	<circle class="st2" cx="747.7" cy="293.5" r="14.5"/>
	<circle class="st3" cx="747.7" cy="293.5" r="13"/>
	<circle class="st4" cx="747.7" cy="293.5" r="11.7"/>
	<g>
		<path class="st5" d="M747.7,305.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C760.1,300.3,754.6,305.9,747.7,305.9z M747.7,282.4c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C758.8,287.4,753.8,282.4,747.7,282.4L747.7,282.4z"/>
		<g>
			<path class="st6" d="M751.3,291.8c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C751.6,292.2,751.5,291.9,751.3,291.8z"/>
			<path class="st6" d="M743.5,290c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C743.4,289.6,743.3,289.8,743.5,290L743.5,290z"/>
			<path class="st6" d="M754.8,288.3h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5h-6.3c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6V289C755.3,288.5,755.1,288.3,754.8,288.3z M754.5,297.9h-0.8l0,0H743l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4v8.8H754.5z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(18)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(18)">
	<circle class="st2" cx="710.2" cy="327" r="14.5"/>
	<circle class="st3" cx="710.2" cy="327" r="13"/>
	<circle class="st4" cx="710.2" cy="327" r="11.7"/>
	<g>
		<path class="st5" d="M710.2,339.4c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
			C722.6,333.8,717.1,339.4,710.2,339.4z M710.2,315.9c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
			C721.3,320.8,716.3,315.9,710.2,315.9L710.2,315.9z"/>
		<g>
			<path class="st6" d="M713.9,325.3c-0.2-0.1-0.4-0.1-0.6,0.1c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7-0.4-0.9-0.7
				c-0.1-0.2-0.4-0.2-0.6-0.1l0,0c-0.1,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3-0.1-0.6-0.3-0.7-0.6
				c-0.1-0.2-0.3-0.3-0.6-0.2c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.3-0.5,0.7-0.9,0.7c-0.3-0.1-0.5-0.4-0.7-0.6c-0.1-0.2-0.4-0.2-0.6-0.1
				l0,0c-0.2,0.1-0.2,0.4-0.1,0.6c0.2,0.4,0.5,0.6,0.9,0.9c0,0,0.1,0.1,0.2,0.1h0.1c0.1,0,0.2,0,0.3,0h0.1c0.3-0.5,1-0.7,1.6-0.3
				c0.1,0.1,0.2,0.2,0.3,0.3h0.4c0.3-0.5,1-0.7,1.6-0.3c0.1,0.1,0.2,0.2,0.3,0.3h0.2c0.1,0,0.2,0,0.3,0h0.1c0.1,0,0.1,0,0.2-0.1
				c0.4-0.2,0.7-0.5,0.9-0.9C714.1,325.7,714.1,325.4,713.9,325.3z"/>
			<path class="st6" d="M706,323.5c0.3,0.4,0.6,0.7,1,0.9c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.2,0,0.3,0h0.1
				c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1h0.2h0.1c0.5-0.6,1.3-0.7,1.9-0.2c0.1,0.1,0.2,0.1,0.2,0.2h0.1
				c0.1,0,0.2,0,0.3,0s0.1,0,0.2,0c0.1,0,0.1,0,0.2-0.1c0.4-0.2,0.8-0.5,1.1-0.9c0.1-0.2,0.1-0.4-0.1-0.6c0,0,0,0-0.1,0
				c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.5,0.5-0.8,0.6c-0.4,0-0.7-0.4-1-0.7c-0.2-0.2-0.5-0.2-0.7-0.1c-0.1,0-0.1,0.1-0.2,0.2
				c-0.2,0.5-0.6,0.7-1.1,0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1-0.1-0.1-0.2-0.2c-0.2-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.6,0.7-1,0.7
				c-0.3-0.1-0.6-0.3-0.8-0.6c-0.2-0.2-0.5-0.2-0.7-0.1C705.9,323,705.9,323.3,706,323.5L706,323.5z"/>
			<path class="st6" d="M717.3,321.8h-0.9c-0.2,0-0.5,0.2-0.5,0.4l-2,5.4c-0.1,0.3-0.3,0.5-0.6,0.5H707c-0.2,0-0.5-0.2-0.5-0.4
				l-2-5.4c-0.1-0.2-0.3-0.4-0.5-0.4h-0.9c-0.3,0-0.6,0.3-0.6,0.6v9.3c0,0.3,0.3,0.6,0.6,0.6h1.7h0.6h9.5l0,0h2.3
				c0.3,0,0.6-0.3,0.6-0.6v-9.3C717.9,322,717.6,321.8,717.3,321.8z M717,331.4h-0.8l0,0h-10.8l0,0h-2.1v-8.8h0.4l2,5.4
				c0,0,0.2,0.8,0.8,0.8s6.4,0,7.2,0c0.7,0,0.9-0.8,0.9-0.8l2-5.4h0.4L717,331.4L717,331.4z"/>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(28)">
	<circle class="st2" cx="586.1" cy="549.5" r="14.5"/>
	<circle class="st3" cx="586.1" cy="549.5" r="13"/>
	<circle class="st4" cx="586.1" cy="549.5" r="11.7"/>
	<path class="st5" d="M586.1,561.9c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C598.5,556.4,592.9,561.9,586.1,561.9z M586.1,538.4c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C597.2,543.4,592.2,538.4,586.1,538.4L586.1,538.4z"/>
	<path class="st6" d="M586.1,549.5L586.1,549.5L586.1,549.5z"/>
	<g>
		<g>
			<g>
				<path d="M590.1,544.5h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6H582c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C591.4,545,590.8,544.5,590.1,544.5z M584,544.3h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3H584V544.3z M590.8,555.1c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4
					c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V545h1.2c0.4,0,0.7,0.3,0.7,0.7L590.8,555.1
					L590.8,555.1z"/>
				<path d="M584.8,550c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C584.9,550.3,585,550.1,584.8,550L584.8,550z"/>
				<path d="M589.5,550.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S589.7,550.7,589.5,550.7z"/>
				<path d="M584.8,547.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C584.9,547.7,585,547.5,584.8,547.4L584.8,547.4z"/>
				<path d="M589.5,548.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C589.8,548.2,589.7,548.1,589.5,548.1z"/>
				<path d="M584.8,552.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C584.9,552.9,585,552.7,584.8,552.6L584.8,552.6z"/>
				<path d="M589.5,553.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S589.7,553.3,589.5,553.3z"/>
			</g>
		</g>
	</g>
</g>
<g @click="mostarIntervencao(30)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(30)">
	<circle class="st2" cx="675" cy="511.3" r="14.5"/>
	<circle class="st3" cx="675" cy="511.3" r="13"/>
	<circle class="st4" cx="675" cy="511.3" r="11.7"/>
	<path class="st5" d="M675,523.7c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C687.4,518.2,681.8,523.7,675,523.7z M675,500.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C686,505.2,681.1,500.2,675,500.2L675,500.2z"/>
	<path class="st6" d="M675,511.3L675,511.3L675,511.3z"/>
	<g>
		<g>
			<g>
				<path d="M679,506.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C680.3,506.8,679.7,506.3,679,506.3z
					 M672.8,506.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					L672.8,506.1L672.8,506.1z M679.7,516.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L679.7,516.9L679.7,516.9z"/>
				<path d="M673.7,511.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C673.8,512.1,673.8,511.9,673.7,511.8L673.7,511.8z"/>
				<path d="M678.4,512.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S678.6,512.5,678.4,512.5z"/>
				<path d="M673.7,509.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C673.8,509.5,673.8,509.3,673.7,509.1
					C673.7,509.2,673.7,509.1,673.7,509.1z"/>
				<path d="M678.4,509.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C678.7,510,678.6,509.8,678.4,509.8z"/>
				<path d="M673.7,514.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C673.8,514.7,673.8,514.5,673.7,514.4L673.7,514.4z"/>
				<path d="M678.4,515.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S678.6,515.1,678.4,515.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(29)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(29)">
	<circle class="st2" cx="587.6" cy="660.8" r="14.5"/>
	<circle class="st3" cx="587.6" cy="660.8" r="13"/>
	<circle class="st4" cx="587.6" cy="660.8" r="11.7"/>
	<path class="st5" d="M587.6,673.2c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C600,667.7,594.5,673.2,587.6,673.2z M587.6,649.7c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C598.7,654.7,593.8,649.7,587.6,649.7L587.6,649.7z"/>
	<path class="st6" d="M587.6,660.8L587.6,660.8L587.6,660.8z"/>
	<g>
		<g>
			<g>
				<path d="M591.6,655.7h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2V657
					C593,656.3,592.4,655.8,591.6,655.7z M585.5,655.6h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L585.5,655.6L585.5,655.6z M592.4,666.4c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					V657c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L592.4,666.4L592.4,666.4z"/>
				<path d="M586.4,661.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C586.5,661.6,586.5,661.4,586.4,661.2
					C586.4,661.3,586.4,661.2,586.4,661.2z"/>
				<path d="M591.1,661.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S591.2,661.9,591.1,661.9z"/>
				<path d="M586.4,658.6c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C586.5,659,586.5,658.8,586.4,658.6L586.4,658.6z"/>
				<path d="M591.1,659.3h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S591.2,659.3,591.1,659.3z"/>
				<path d="M586.4,663.9c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C586.5,664.2,586.5,664,586.4,663.9L586.4,663.9z"/>
				<path d="M591.1,664.6h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C591.4,664.7,591.2,664.6,591.1,664.6z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(27)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(27)">
	<circle class="st2" cx="261.2" cy="496.6" r="14.5"/>
	<circle class="st3" cx="261.2" cy="496.6" r="13"/>
	<circle class="st4" cx="261.2" cy="496.6" r="11.7"/>
	<path class="st5" d="M261.2,509c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C273.6,503.5,268.1,509,261.2,509z M261.2,485.5c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C272.3,490.5,267.3,485.5,261.2,485.5L261.2,485.5z"/>
	<path class="st6" d="M261.2,496.6L261.2,496.6L261.2,496.6z"/>
	<g>
		<g>
			<g>
				<path d="M265.2,491.5H264V491c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C266.5,492.1,265.9,491.5,265.2,491.5
					z M259.1,491.4h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					L259.1,491.4L259.1,491.4z M265.9,502.2c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7V502.2L265.9,502.2z"/>
				<path d="M259.9,497c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C260.1,497.4,260.1,497.2,259.9,497C259.9,497.1,259.9,497,259.9,497z"/>
				<path d="M264.6,497.7h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C264.9,497.9,264.8,497.7,264.6,497.7z"/>
				<path d="M259.9,494.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1L258,495c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C260.1,494.8,260.1,494.6,259.9,494.4L259.9,494.4z"/>
				<path d="M264.6,495.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C264.9,495.3,264.8,495.1,264.6,495.1z"/>
				<path d="M259.9,499.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1s0.2,0,0.2-0.1l1.3-1.2C260.1,500,260.1,499.8,259.9,499.7L259.9,499.7z"/>
				<path d="M264.6,500.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S264.8,500.4,264.6,500.4z"
					/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(26)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(26)">
	<circle class="st2" cx="608.9" cy="798.3" r="14.5"/>
	<circle class="st3" cx="608.9" cy="798.3" r="13"/>
	<circle class="st4" cx="608.9" cy="798.3" r="11.7"/>
	<path class="st5" d="M608.9,810.7c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4l0,0
		C621.3,805.1,615.7,810.7,608.9,810.7z M608.9,787.2c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C619.9,792.2,615,787.2,608.9,787.2L608.9,787.2z"/>
	<path class="st6" d="M608.9,798.3L608.9,798.3L608.9,798.3z"/>
	<g>
		<g>
			<g>
				<path d="M612.9,793.2h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C614.2,793.8,613.6,793.2,612.9,793.2z M606.7,793.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L606.7,793.1L606.7,793.1z M613.6,803.9c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7
					L613.6,803.9L613.6,803.9z"/>
				<path d="M607.6,798.7c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C607.7,799.1,607.7,798.9,607.6,798.7L607.6,798.7z"/>
				<path d="M612.3,799.4h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C612.6,799.6,612.5,799.4,612.3,799.4z"/>
				<path d="M607.6,796.1c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C607.7,796.5,607.7,796.3,607.6,796.1L607.6,796.1z"/>
				<path d="M612.3,796.8h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S612.5,796.8,612.3,796.8z"/>
				<path d="M607.6,801.3c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C607.7,801.7,607.7,801.5,607.6,801.3L607.6,801.3z"/>
				<path d="M612.3,802h-3.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3C612.6,802.2,612.5,802,612.3,802z"
					/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(23)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(23)">
	<circle class="st2" cx="769" cy="400.3" r="14.5"/>
	<circle class="st3" cx="769" cy="400.3" r="13"/>
	<circle class="st4" cx="769" cy="400.3" r="11.7"/>
	<path class="st5" d="M769,412.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4l0,0
		C781.4,407.2,775.9,412.8,769,412.8z M769,389.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C780.1,394.2,775.1,389.3,769,389.3L769,389.3z"/>
	<path class="st6" d="M769,400.3L769,400.3L769,400.3z"/>
	<g>
		<g>
			<g>
				<path d="M773,395.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1h-0.9c-0.2,0-0.4,0.1-0.4,0.3
					v0.6H765c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4C774.4,395.9,773.8,395.3,773,395.3z
					 M766.9,395.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2
					L766.9,395.1L766.9,395.1z M773.8,406c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8
					c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3v-0.8h1.2c0.4,0,0.7,0.3,0.7,0.7L773.8,406L773.8,406z"/>
				<path d="M767.8,400.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C767.9,401.1,767.9,400.9,767.8,400.8L767.8,400.8z"/>
				<path d="M772.5,401.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S772.6,401.5,772.5,401.5z"
					/>
				<path d="M767.8,398.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C767.9,398.5,767.9,398.3,767.8,398.2L767.8,398.2z"/>
				<path d="M772.5,398.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S772.6,398.9,772.5,398.9z"
					/>
				<path d="M767.8,403.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C767.9,403.7,767.9,403.5,767.8,403.4L767.8,403.4z"/>
				<path d="M772.5,404.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S772.6,404.1,772.5,404.1z"
					/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
<g @click="mostarIntervencao(24)">
	<v-touch tag="a" v-on:tap="mostarIntervencao(24)">
	<circle class="st2" cx="814.5" cy="331.4" r="14.5"/>
	<circle class="st3" cx="814.5" cy="331.4" r="13"/>
	<circle class="st4" cx="814.5" cy="331.4" r="11.7"/>
	<path class="st5" d="M814.5,343.8c-6.9,0-12.4-5.6-12.4-12.4c0-6.9,5.6-12.4,12.4-12.4s12.4,5.6,12.4,12.4l0,0
		C826.9,338.2,821.4,343.8,814.5,343.8z M814.5,320.3c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1s11.1-5,11.1-11.1l0,0
		C825.6,325.3,820.6,320.3,814.5,320.3L814.5,320.3z"/>
	<path class="st6" d="M814.5,331.4L814.5,331.4L814.5,331.4z"/>
	<g>
		<g>
			<g>
				<path d="M818.5,326.3h-1.2v-0.6c0-0.2-0.2-0.3-0.4-0.3h-1c-0.2-0.7-0.8-1-1.5-1c-0.6,0-1.2,0.4-1.5,1H812
					c-0.2,0-0.4,0.1-0.4,0.3v0.6h-1.2c-0.7,0-1.3,0.6-1.4,1.3v9.4c0,0.7,0.7,1.2,1.4,1.2h8c0.7,0,1.4-0.5,1.4-1.2v-9.4
					C819.8,326.9,819.2,326.3,818.5,326.3z M812.4,326.1h0.9c0.2,0,0.3-0.1,0.3-0.3c0.1-0.4,0.5-0.7,0.9-0.7s0.8,0.3,0.9,0.7
					c0,0.2,0.2,0.3,0.3,0.3h0.9v1.3h-4.2L812.4,326.1L812.4,326.1z M819.2,337c0,0.4-0.4,0.6-0.7,0.6h-8c-0.4,0-0.7-0.2-0.7-0.6
					v-9.4c0-0.4,0.3-0.7,0.7-0.7h1.2v0.8c0,0.2,0.2,0.3,0.4,0.3h4.8c0.2,0,0.4-0.1,0.4-0.3V327h1.2c0.4,0,0.7,0.3,0.7,0.7L819.2,337
					L819.2,337z"/>
				<path d="M813.2,331.8c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C813.4,332.1,813.4,332,813.2,331.8L813.2,331.8z"/>
				<path d="M817.9,332.5h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C818.2,332.7,818.1,332.5,817.9,332.5z"/>
				<path d="M813.2,329.2c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C813.4,329.5,813.4,329.3,813.2,329.2L813.2,329.2z"/>
				<path d="M817.9,329.9h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3S818.1,329.9,817.9,329.9z"
					/>
				<path d="M813.2,334.4c-0.1-0.1-0.3-0.1-0.5,0l-1,1l-0.4-0.5c-0.1-0.1-0.3-0.1-0.5,0c-0.1,0.1-0.1,0.3,0,0.5l0.7,0.7
					c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l1.3-1.2C813.4,334.8,813.4,334.6,813.2,334.4L813.2,334.4z"/>
				<path d="M817.9,335.1h-3.8c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3h3.8c0.2,0,0.3-0.1,0.3-0.3
					C818.2,335.3,818.1,335.1,817.9,335.1z"/>
			</g>
		</g>
	</g>
	</v-touch>
</g>
</svg>

         </SvgPanZoom>
      </div>
    </div>
  </div>
</template>


<script>
import SvgPanZoom from 'vue-svg-pan-zoom';
import { mapActions } from 'vuex'
import Modal from '@/components/ModalMapas.vue'

export default {
	components: { SvgPanZoom, Modal },

	data () {
		return {
				informacoes: [
						{
							id: 1,
							titulo: 'Barragem Rio de Contas',
							desc: 'Abastecimento humano, dessedentação animal e irrigação nos municípios da bacia do rio de Contas',
							estagio: 'EVTEA',
							valor: 'R$ 168,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_BA-035.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 2,
							titulo: 'Eixo de Transposição Tocantins-São Francisco',
							desc: 'Reforço da oferta hídrica de 27 municípios na bacia do rio São Francisco e viabilização da navegação nos rios Preto e Grande',
							estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
							valor: 'R$ 18,50 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 3,
							titulo: 'Eixo de Integração Santa Helena-Joanes II',
							desc: 'Abastecimento humano de Salvador, Lauro de Freitas, Simões Filho, Madre de Deus, São Francisco do Conde e Candeias',
							estagio: 'Obra',
							valor: 'R$ 330,97 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-002_003_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 4,
							titulo: 'Sistema Adutor Pedra do Cavalo (Ampliação-3ª Etapa)',
							desc: 'Abastecimento humano de Salvador, Lauro de Freitas e Simões Filho',
							estagio: 'Projeto Básico',
							valor: 'R$ 201,84 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-002_003_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 5,
							titulo: 'Sistema Adutor Juazeiro-Senhor do Bonfim',
							desc: 'Abastecimento humano e dessedentação animal em 43 municípios das bacias dos rios Salitre, Curaçá, Itapicuru e Paraguaçu',
							estagio: 'Projeto Básico',
							valor: 'R$ 678,21 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-006.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 6,
							titulo: 'Sistema Adutor Vitória da Conquista (ampliação)',
							desc: 'Abastecimento humano de Vitória da Conquista, Belo Campo e Tremedal, com captação na barragem de Catolé',
							estagio: 'Obra',
							valor: 'R$ 109,14 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-008_BA-031.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 7,
							titulo: 'Sistema Adutor Vitória da Conquista (ampliação)',
							desc: 'Abastecimento humano de Vitória da Conquista, Belo Campo e Tremedal, com captação na barragem de Catolé',
							estagio: 'Obra',
							valor: 'R$ 109,14 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-008_BA-031.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 8,
							titulo: 'Sistema Adutor Águas do Sertão – Blocos Noroeste-Sudeste e Centro',
							desc: 'Abastecimento humano e usos multiplos em 14 municípios das bacias dos rios Itapicuru, Paraguaçu e do Recôncavo',
							estagio: 'EVTEA',
							valor: 'R$ 79,75 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-016dgh_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 9,
							titulo: 'Sistema Adutor Feira de Santana (ampliação)',
							desc: 'Abastecimento humano de Feira de Santana, Conceição da Feira, São Gonçalo dos Campos, Humildes, Santa Bárbara, Santanópolis e Tanquinho',
							estagio: 'Obra',
							valor: 'R$ 361,47 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-007.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 10,
							titulo: 'Barragem Catolé',
							desc: 'Abastecimento humano de Vitória da Conquista, Belo Campo e Tremedal',
							estagio: 'Obra',
							valor: 'R$ 172,81 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-008_BA-031.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 11,
							titulo: 'Barragem Rio de Contas',
							desc: 'Abastecimento humano, dessedentação animal e irrigação nos municípios da bacia do rio de Contas',
							estagio: 'EVTEA',
							valor: 'R$ 168,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_BA-035.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 12,
							titulo: 'Canal do Sertão Alagoano (Trecho IV)',
							desc: 'Usos múltiplos em 42 municípios do semiárido alagoano',
							estagio: 'Obra',
							valor: 'R$ 150 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_AL-001b.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 13,
							titulo: 'Canal do Sertão Alagoano (Trecho V)',
							desc: 'Usos múltiplos em 42 municípios do semiárido alagoano',
							estagio: 'EVTEA',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_AL-001.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 14,
							titulo: 'Canal do Sertão Alagoano (Trechos VI, VII e VIII - Km 150 a 250)',
							desc: 'Usos múltiplos em 42 municípios do semiárido alagoano',
							estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
							valor: 'R$ 18,50 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 15,
							titulo: 'Sistema Adutor Meirim',
							desc: 'Abastecimento humano de Maceió',
							estagio: 'Obra',
							valor: 'R$ 118,07 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_AL-003_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 16,
							titulo: 'Sistema Adutor da Região Norte',
							desc: 'Abastecimento humano em onze municípios nas bacias Litorânea e do rio Camaragibe',
							estagio: 'EVTEA',
							valor: 'R$ 64,74 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_AL-013.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 17,
							titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Maceió',
							desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Maceió',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Maceio.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 18,
							titulo: 'Canal do Xingó',
							desc: 'Usos múltiplos em Canindé de São Francisco, Monte Alegre de Sergipe, Nossa Senhora da Glória, Poço Redondo, Porto da Folha, em Sergipe e Paulo Afonso e Santa Brígida, na Bahia',
							estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
							valor: 'R$ 18,50 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 19,
							titulo: 'Sistema Adutor São Francisco (3ª Fase - ampliação)',
							desc: 'Abastecimento humano e industrial nos municípios de Aracaju, Barra dos Coqueiros, São Cristóvão e Nossa Senhora do Socorro',
							estagio: 'Obra',
							valor: 'R$ 160,34 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SE-001_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 20,
							titulo: 'Sistema Adutor do Agreste (ampliação)',
							desc: 'Abastecimento humano de  Areia Branca, Campo do Brito, Itabaiana, Macambira e São Domingos.',
							estagio: 'Obra',
							valor: 'R$ 44,15 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SE-003.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 21,
							titulo: 'Sistema Adutor Alto Sertão (ampliação)',
							desc: 'Abastecimento humano de Nossa Senhora da Glória, Nossa Senhora Aparecida, São Miguel do Aleixo, Ribeirópolis, Moita Bonita, Frei Paulo, Pinhão e Pedra Mole',
							estagio: 'EVTEA',
							valor: 'R$ 0,40 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_EVTEA_SE-008.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 22,
							titulo: 'Barragem Rio Vaza-Barris',
							desc: 'Abastecimento humano e irrigação nos municípios de Areia Branca, Campo do Brito, Itabaiana, Macambira, São Domingos, Poço Verde, Simão Dias, Lagarto e Riachão do Dantas',
							estagio: 'Anteprojeto',
							valor: 'R$ 406,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_SE-013.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 23,
							titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Aracaju',
							desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Aracaju',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Aracaju.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 24,
							titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Maceió',
							desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Maceió',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Maceio.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 25,
							titulo: 'Sistema Adutor Águas do Sertão – Bloco Sudoeste',
							desc: 'Abastecimento humano e usos múltiplos em 13 municípios nas bacias dos rios Itapicuru, Paraguaçu e do Recôncavo, com águas provenientes do aquífero Tucano',
							estagio: 'Obra',
							valor: 'R$ 331,25 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/Ficha_RIO_BA-016ef_Uni_LP.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 26,
							titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacias Hidrográficas Costeiras do Sul da Bahia e do Espírito Santo',
							desc: 'Definição de alternativas de aproveitamento de rec. hídricos para suprim. dos deficits em áreas de baixo grau de segurança hídrica nas bacias costeiras do sul da Bahia e do Espírito Santo',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 1,80 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacias Costeiras Sul BA e ES.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 27,
							titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Margem Esquerda do rio São Francisco',
							desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica na margem esquerda do rio São Francisco',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 1,80 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Margem Esquerda do SF.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 28,
							titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica – Bacia Hidrográfica do Rio de Contas',
							desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica na bacia hidrográfica do rio de Contas',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 1,80 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacia Rio de Contas.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 29,
							titulo: 'Estudo de Alternativas para o Aproveitamento de Recursos Hídricos em Áreas de Baixo Grau de Segurança Hídrica - Bacias Hidrográficas dos rios Pardo e Jequitinhonha',
							desc: 'Definição de alternativas de aproveitamento de recursos hídricos para suprimento dos deficits em áreas de baixo grau de segurança hídrica nas bacias dos rios Pardo e Jequitinhonha',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 1,80 milhão',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR Lacunas-Bacias Pardo e Jequitinhonha.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 30,
							titulo: 'Estudo de Aproveitamento de Recursos Hídricos para a RM Salvador',
							desc: 'Definição e detalhamento de alternativas para o abastecimento humano da Região Metropolitana de Salvador',
							estagio: 'Estudo de Aproveitamento de Recursos Hídricos',
							valor: 'R$ 3,00 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_RM_Salvador.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
					{
							id: 31,
							titulo: 'Canal do Sertão Baiano (Eixo Sul)',
							desc: 'Usos múltiplos de 54 municípios das bacias hidrográficas de Tatauí, Salitre, Tourão/Porções, Vaza-Barris, Itapicuru e Jacuípe',
							estagio: 'Detalhamento de Planos de Desenvolvimento Regional',
							valor: 'R$ 18,50 milhões',
							icons: null,
							show: true,
							pdf: 'http://arquivos.ana.gov.br/pnsh/TR_EDRI.pdf',
							posicao: {
								top: 20,
								left: 20,
								right: 0,
								bottom: 0
							},
					},
				]
		}
	},

  methods: {
    ...mapActions({
        showModal: 'Layout/enviarInformacaoModal'
    }),
    mostarIntervencao (item, evt) {

      let payload = this.informacoes.filter((value) => {
          return value.id === item
			})

      this.showModal(payload[0]);
    }
  }
}
</script>


<style lang="scss" scoped>

		.title-section {
			padding-left: 0px;
		}

    svg {
    height: 450px;
    width: 100%;
        @media (max-height:  900px) and (min-width: 1200px)   {
            height: 350px;
        }
    }

    .interacao-intervencao {
	display: flex;
	align-items: center;
    width: 289px;
    @include media_tablet() {
      display: none;
    }
	svg {
		width: 22px;
		height: 22px;
		margin-right: 10px;
	}

	p {
		font-family: 'rubik_italic';
		font-size: 12px;
		line-height: 16px;
	}
}


	.st0{fill:#3B6EB6;}
	.st1{fill:#EAE0B5;}
	.st2{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}
	.st3{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}
	.st4{fill:#FFFFFF;}
	.st5{fill:#8FC74B;}
	.st6{fill:#010101;}
</style>
